export const ShareCart = 'ShareCart';
export const IndividualCart = 'IndividualCart';
